declare const __TEO_DEFAULT_API_BASE__: string | undefined;

/** API origin baked at loader build time (`VITE_TEO_API_BASE`). */
export function getBakedWidgetApiBase(): string {
  try {
    const raw =
      typeof __TEO_DEFAULT_API_BASE__ !== 'undefined'
        ? __TEO_DEFAULT_API_BASE__
        : '';
    return String(raw).trim().replace(/\/$/, '');
  } catch {
    return '';
  }
}
